import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const ViewGenericAccountWrapper = styled.div`
  color: ${COLORS.cirrus_black};

  .MuiPopper-root {
    inset: 10px auto auto -50px !important;
  }
  .separator-space {
    margin: 16px 0px;
  }

  .container-bottom {
    ${responsive.MOBILE`
      padding: 0 8px 16px 8px;
      margin: 16px 0;
    `}
  }
`;
